import React, { memo, VFC } from "react";
import { getCurrentProjectId } from "~/lib/utils/urlHelper";
import { Project, PROJECT_ID_PRICE_RANK_DEV } from "~/models/project";
import FooterPresenter from "faqSrc/components/modules/footer/FooterPresenter";
import PriceRankDevFooterPresenter from "./PriceRankDevFooterPresenter";

interface Props {
  asPath?: string;
  languageAlts?: string[];
  project?: Project;
}

const Footer: VFC<Props> = ({ asPath, languageAlts, project }) => {
  const projectId = getCurrentProjectId();
  if (projectId === PROJECT_ID_PRICE_RANK_DEV) {
    return (
      <PriceRankDevFooterPresenter
        asPath={asPath}
        languageAlts={languageAlts}
      />
    );
  }

  return <FooterPresenter project={project} />;
};

export default memo(Footer);
